<template>
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2980.000000 648.000000" preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,648.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
      <path d="M260 3260 l0 -3000 463 2 462 3 0 2995 0 2995 -462 3 -463 2 0 -3000z" />
      <path
        d="M2960 3260 l0 -3000 463 2 462 3 0 2995 0 2995 -462 3 -463 2 0
-3000z" />
      <path
        d="M7555 6251 c-8 -13 -64 -189 -225 -701 -29 -91 -65 -203 -80 -250
-15 -47 -44 -139 -65 -205 -21 -66 -43 -138 -50 -160 -21 -64 -126 -397 -137
-435 -6 -19 -14 -44 -18 -55 -4 -11 -27 -81 -50 -155 -23 -74 -59 -189 -80
-255 -21 -66 -59 -187 -85 -270 -26 -82 -60 -188 -75 -235 -15 -47 -51 -159
-80 -250 -120 -382 -144 -459 -170 -540 -37 -116 -117 -368 -185 -585 -31 -99
-69 -218 -84 -265 -37 -113 -58 -180 -126 -395 -70 -224 -149 -473 -185 -585
-15 -47 -49 -152 -75 -235 -26 -82 -64 -205 -86 -272 -21 -67 -39 -128 -39
-137 0 -14 48 -16 475 -16 l474 0 14 28 c8 15 24 61 36 102 13 41 31 100 41
130 10 30 41 129 70 220 28 91 71 226 95 300 23 74 62 196 85 270 23 74 49
155 57 180 18 54 174 552 198 630 10 30 21 64 25 75 4 11 17 49 28 85 127 405
214 681 262 830 15 47 51 159 79 250 29 91 72 228 97 305 24 77 58 185 75 240
18 55 44 138 59 185 29 89 79 248 181 572 13 43 27 78 31 78 5 0 9 -1005 10
-2232 l3 -2233 460 0 460 0 0 2995 0 2995 -707 3 c-440 1 -709 -1 -713 -7z" />
      <path
        d="M12780 3260 l0 -3001 1498 4 c1160 3 1508 6 1547 16 28 7 91 22 140
33 298 67 605 245 836 484 64 67 219 263 219 277 0 3 17 34 38 68 37 62 46 79
90 179 34 78 80 225 104 337 20 95 23 136 23 338 0 201 -3 244 -23 339 -73
346 -240 658 -483 896 -62 61 -167 153 -180 158 -18 7 -8 31 39 93 436 578
466 1376 75 1981 -249 385 -656 666 -1098 758 -27 5 -72 15 -100 21 -36 9
-423 13 -1387 16 l-1338 4 0 -3001z m2622 2039 c200 -40 387 -168 501 -343 71
-108 96 -169 122 -306 19 -94 19 -155 1 -251 -29 -151 -83 -267 -175 -376
-108 -128 -241 -214 -411 -264 -74 -22 -84 -22 -888 -26 -618 -3 -817 -1 -828
8 -12 10 -14 126 -14 784 0 424 3 775 7 778 11 12 1626 8 1685 -4z m371 -2541
c310 -108 510 -341 558 -652 12 -74 6 -229 -9 -281 -6 -16 -16 -50 -23 -75 -7
-25 -30 -78 -50 -118 -98 -192 -266 -329 -494 -404 l-70 -23 -979 -3 c-790 -2
-981 0 -988 10 -9 15 -11 1538 -2 1563 6 14 91 15 993 13 l986 -4 78 -26z" />
      <path
        d="M18305 6248 c-3 -7 -4 -1356 -3 -2998 l3 -2985 1900 0 1900 0 3 459
c2 361 0 461 -10 468 -7 4 -653 8 -1435 8 l-1423 0 0 793 0 794 542 6 c298 4
878 7 1290 7 l748 0 -2 463 -3 462 -1285 5 -1285 5 -3 793 -2 792 1422 0 c783
0 1429 4 1436 8 10 7 12 107 10 468 l-3 459 -1898 3 c-1513 2 -1899 0 -1902
-10z" />
      <path
        d="M23385 6248 c-3 -7 -4 -1356 -3 -2998 l3 -2985 459 -3 c361 -2 461 0
468 10 4 7 8 1016 9 2243 0 1236 4 2219 9 2205 5 -14 30 -92 55 -175 26 -82
51 -159 55 -170 4 -11 22 -67 40 -125 18 -58 50 -161 72 -230 78 -247 151
-477 178 -560 15 -47 42 -132 60 -190 18 -58 41 -130 51 -160 26 -81 81 -257
129 -410 23 -74 54 -173 69 -220 44 -136 66 -204 126 -395 31 -99 60 -191 65
-205 5 -14 32 -99 61 -190 28 -91 71 -226 95 -300 23 -74 61 -196 85 -270 23
-74 54 -173 69 -220 15 -47 51 -159 80 -250 28 -91 68 -217 89 -280 l38 -115
710 -3 c561 -2 712 1 720 10 10 14 9 13 83 248 47 150 84 265 143 450 63 199
77 244 107 340 18 58 45 143 61 190 15 47 44 139 64 205 20 66 50 158 65 205
15 47 42 132 60 190 18 58 36 114 40 125 4 11 25 74 45 140 65 210 96 309 105
335 5 14 32 99 61 190 28 91 71 226 95 300 93 296 123 391 164 520 23 74 51
160 60 190 10 30 44 136 75 235 31 99 60 191 65 205 5 14 27 86 50 160 64 206
67 214 79 218 8 3 12 -594 13 -2220 l3 -2223 463 -3 462 -2 0 3000 0 3000
-712 -2 -713 -3 -36 -110 c-20 -60 -50 -155 -68 -210 -17 -55 -51 -163 -76
-240 -24 -77 -67 -214 -96 -305 -28 -91 -64 -203 -79 -250 -27 -83 -84 -264
-177 -560 -25 -80 -49 -154 -53 -165 -4 -11 -18 -54 -30 -95 -13 -41 -40 -129
-61 -195 -21 -66 -43 -133 -48 -150 -5 -16 -29 -93 -54 -170 -25 -77 -64 -201
-87 -275 -23 -74 -54 -173 -69 -220 -16 -47 -37 -114 -48 -150 -59 -186 -96
-300 -143 -450 -28 -91 -60 -190 -70 -220 -9 -30 -36 -113 -58 -185 -71 -226
-153 -487 -182 -575 -15 -47 -47 -146 -70 -220 -23 -74 -62 -196 -85 -270 -24
-74 -46 -146 -50 -158 -7 -22 -8 -23 -19 -5 -7 10 -18 38 -26 63 -7 25 -25 83
-41 130 -25 79 -98 308 -156 495 -14 44 -33 105 -43 135 -10 30 -37 116 -60
190 -24 74 -54 169 -67 210 -14 41 -58 181 -98 310 -71 226 -96 306 -155 490
-28 87 -80 252 -170 540 -28 91 -55 174 -60 185 -4 11 -22 67 -40 125 -18 58
-52 166 -75 240 -24 74 -67 209 -95 300 -29 91 -65 203 -80 250 -27 86 -59
188 -126 400 -20 63 -44 140 -54 170 -10 30 -37 116 -60 190 -23 74 -50 160
-60 190 -17 53 -110 345 -152 480 -12 36 -25 71 -31 78 -7 9 -162 12 -714 12
-554 0 -705 -3 -708 -12z" />
    </g>
  </svg>
</template>
